/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoPoint } from './geoPoint';


export interface GetLoyaltyProductsOnMapRequestDto { 
    /**
     * Id города
     */
    cityId: number;
    lowerLeftCorner: GeoPoint;
    upperRightCorner: GeoPoint;
    /**
     * Часть названия или описания объявления
     */
    nameTemplate?: string;
    /**
     * Список ID категорий
     */
    categoryIds?: Array<string>;
}

